/**
 * 세션 스토리지 키 상수 정의
 * 모든 sessionStorage 키는 이 클래스를 통해 관리됩니다.
 */
class SessionStorageKey {
}
// 심볼 리스트 관련
Object.defineProperty(SessionStorageKey, "SYMBOL_LIST_SEARCH_QUERY", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'symbol-list-search-query'
});
/** desktop 주문 화면(탭·잔고 검색·주문/청산 기간 필터) */
Object.defineProperty(SessionStorageKey, "ORDER_SCREEN_FILTERS_WTS", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'order-screen-filters-wts'
});
/** mobile 주문 화면(탭·필터·주문·청산 기간) */
Object.defineProperty(SessionStorageKey, "ORDER_SCREEN_FILTERS_MTS", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'order-screen-filters-mts'
});
/** 거래내역(주문체결·청산손익·결제내역·스왑이자) 필터 — 앱별 빌드 분리로 동일 키 사용 */
Object.defineProperty(SessionStorageKey, "TRADE_SCREEN_FILTERS", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'trade-screen-filters'
});
export default SessionStorageKey;
//# sourceMappingURL=session-storage-key.js.map